function dataURLToBlob(dataUrl: string) {
  const [header, base64] = dataUrl.split(",");
  const mime = header.match(/data:(.*?);/)[1];
  const name = decodeURIComponent(header.match(/name=([^;]+)/)[1]);
  const binary = atob(base64);
  const array = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new File([array], name, { type: mime });
}

export function convertJSONToMultiPartFormData(body: Object, fileKeys: Array<string>): FormData {
  const formData = new FormData();
  for (const key of Object.keys(body)) {
    if (fileKeys.includes(key)) {
      const file = dataURLToBlob(body[key]);
      formData.append(key, file, file.name);
    } else {
      formData.append(key, body[key]);
    }
  }
  return formData;
}
